import { render } from "./EventsBanner.vue?vue&type=template&id=7e0c15d4"
import script from "./EventsBanner.vue?vue&type=script&lang=js"
export * from "./EventsBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__